import React, { useCallback, useEffect, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { GoogleReCaptcha, GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useNavigate } from "react-router-dom";
import group1 from "../../assets/images/brand/Group1.png";
import group2 from "../../assets/images/brand/Group2.png";
import group3 from "../../assets/images/brand/Group3.png";
import icon from "../../assets/images/brand/logo_2_107x70.png";
import tickGreen from "../../assets/images/gif/geentick.gif";
import InputForm from "../../components/InputForm";
import { ErrorToast, SuccessToast } from "../../components/toastMessage";
import { BASE_URL } from "../../constants/Constants";
import { useUser } from "../../contexts/UserContext";
import { useSetUserRegistration } from "../../contexts/UserRegistrationContext";
import { TRegistrationField } from "../../hooks/registration-field-hooks";
import { _axios } from "../../utils/axios";
import uploadFileToBlob from "../../utils/azure-storage-blob";
import { debounce } from "../../utils/common";
import { cookieUtils } from "../../utils/cookieUtils";
import style from "../verificationPage/verifcation.module.css";
import { validateDocuments } from "./VerificationPage.const";
import { jwtDecode, JwtPayload } from "jwt-decode";
// Extend the JwtPayload interface
interface ExtendedJwtPayload extends JwtPayload {
  verified?: boolean;
}

const VerificationPage = () => {
  const [step, setStep] = useState(1);
  const [emailOTP, setEmailOTP] = useState('');
  const [mobileOTP, setMobileOTP] = useState('');
  const [documentType, setDocumentType] = useState('Aadhaar Card');
  const [documentId, setDocumentId] = useState('');
  const [regestrationFields, setRegestrationFields] = useState<any>([]);
  const [documentConfigList, setDocumentConfigList] = useState<any>();
  const [fileTypes, setFileTypes] = useState<Array<string>>(["JPG", "PNG", "GIF", "PDF"]);
  const setUserRegistration = useSetUserRegistration()
  let navigate = useNavigate();
  const user = useUser();
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [token, setToken] = useState('');
  const [verificationToken, setVerificationToken] = useState(null);

  const [formData, setFormData] = useState<any>(() => {
    // const userData = localStorage.getItem('userDetails')
    const userData = cookieUtils.getSecureCookie('userDetails')
    // let user = cookieUtils.getSecureCookie('userDetails');

    const userParsedData = userData ? userData : {
      name: '',
      email: '',
      mobile_number: ''
    }
    return {
      name: userParsedData?.name,
      email: userParsedData?.email,
      mobile_number: userParsedData?.mobile,
      user_salutation: 'Mr.',
      user_type: 'Architect',
      document_type: 'Aadhaar Card',
      gov_id_number: '',
      office_address: '',
      gov_id_document: '',
      document_certificate: '',
      experience_certificate: '',
      licence_certificate: '',
      email_status: 0,
      mobile_status: 0,
      regestration_status: 0,
    }
  });

  const handleVerify = (token: React.SetStateAction<string>) => {
    setToken(token);
  };



  const convertFileTypeStringToArray = (fileTypesString: string) => {
    // Split the string into an array
    const fileTypesArray = fileTypesString.split(',');

    // Capitalize each element of the array
    const capitalizedFileTypesArray = fileTypesArray.map(fileType => fileType.toUpperCase());

    return capitalizedFileTypesArray;
  }

  const getDocumentConfig = () => {
    _axios.get(`${BASE_URL}/api/document-config/regestration`
    )
      .then(function (response) {
        if (response?.data?.success === 0) {
          ErrorToast(response?.data?.message)
          return
        }
        setDocumentConfigList(response.data.data[0])
        setFileTypes(convertFileTypeStringToArray(response.data.data[0].file_type)?.filter(e => !!e))

        // handle success
        console.log('setDocumentConfigList', response);
      })
      .catch(function (error: any) {
        // handle error
        console.log(error);
      })
      .finally(function () {
        // always executed
      });
  }

  const getRegistrationFields = () => {
    _axios.post(`${BASE_URL}/api/registration-fields`,
      {
        "page": 1,
        "limit": 10
      })
      .then(function (response) {
        if (response?.data?.success === 0) {
          ErrorToast(response?.data?.message)
          return
        }
        setRegestrationFields(response.data.data)

        // handle success
        console.log(response);
      })
      .catch(function (error: any) {
        // handle error
        console.log(error);
      })
      .finally(function () {
        // always executed
      });
  }

  useEffect(() => {
    getRegistrationFields();
    getDocumentConfig()
  }, [])


  const sendEmail = () => {
    // const userData = localStorage.getItem('userDetails')
    const userData = cookieUtils.getSecureCookie('userDetails')

    const userParsedData = userData ? userData : {
      user_id: ''
    }
    _axios.post(`${BASE_URL}/api/email-verification/sent`,
      {
        user_id: userParsedData.user_id,
        name: formData?.name,
        email: formData?.email,
        mobile_number: formData?.mobile_number,
        "token": token
      })
      .then(function (response: any) {
        // console.log('response', response)
        // if (step !== 3) setStep(step + 1)
        // if (response.data.success == 0) {
        //   ErrorToast(response.data.message);

        // }
        // else { SuccessToast('OTP sent Successfully'); }
        console.log('response', response);

        // Store verification token if it exists in response
        if (response.data.verificationToken) {
          setVerificationToken(response.data.verificationToken);
          console.log('Verification token received:', response.data.verificationToken);
        }

        if (step !== 3) setStep(step + 1);

        if (response.data.success === 0) {
          ErrorToast(response.data.message);
        } else {
          SuccessToast('OTP sent Successfully');
        }
      }).catch(function (error) {
        // handle error
        console.log(error);
      })
  }

  const handleNext = async () => {

    // For now until the user verification flow is not done.
    // return navigate('/user-dashboard')

    if (step === 1) {
      // const adharCardRegex = /^([1-9][0-9]{3}[0-9]{4}[0-9]{4})|([1-9][0-9]{3}\s[0-9]{4}\s[0-9]{4})|([1-9][0-9]{3}-[0-9]{4}-[0-9]{4})$/;
      const adharCardRegex = /^(?:\d{4} \d{4} \d{4}|\d{4}-\d{4}-\d{4}|\d{12})$/;

      const drivingLicenceRegex = /^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/gm;
      const panCardRegex = /(^([a-zA-Z]{5})([0-9]{4})([a-zA-Z]{1})$)/;
      const voterCardRegex = /^([a-zA-Z]){3}([0-9]){7}?$/g;
      const passportRegex = /^[A-PR-WY][1-9]\d\s?\d{4}[1-9]$/;
      if (documentType === 'Aadhaar Card') {
        const isValid = adharCardRegex.test(documentId);
        if (!isValid) {
          ErrorToast("Check to ensure you entered the correct 12-digit Aadhaar number");
          return;
        }
      }
      else if (documentType === 'Driving Licence') {
        const isValid = drivingLicenceRegex.test(documentId);
        if (!isValid) {
          ErrorToast("Please ensure that any letters, numbers, or spaces included in your application match those on your physical license.")
          return;
        }
      }
      else if (documentType === 'Pan Card') {
        const isValid = panCardRegex.test(documentId);
        if (!isValid) {
          ErrorToast("Please verify that you have inputted the appropriate 10-character alphanumeric PAN number. For instance: XXXXX0000X.")
          return;
        }
      }
      else if (documentType === 'Voter Card') {
        const isValid = voterCardRegex.test(documentId);
        if (!isValid) {
          ErrorToast("Check that you have provided the correct Voter ID number. Voter ID numbers come in different lengths and formats.")
          return;
        }
      }
      else if (documentType === 'Passport') {
        const isValid = passportRegex.test(documentId);
        if (!isValid) {
          ErrorToast("Ensure that you have entered the correct passport number. Passport numbers typically include both letters and numbers.")
          return;
        }
      }
      let filtredList = regestrationFields?.filter((field: any) => field?.mandatory == 1);
      if (filtredList?.length > 0) {
        let index = filtredList.map((list: any) => list.registration_field_id);
        if (index.includes(7) && formData?.office_address.length < 1) {
          ErrorToast("Please enter valid address");
          return;
        }
      }
      setStep(step + 1)
    }
    else if (step === 2) {
      if (!documentConfigList?.file_size) {
        ErrorToast(`Document Config for Registration Document is not Configured by the Admin`)
      }
      else {
        const validRes = validateDocuments(documentConfigList, formData, formData.user_type)
        if (validRes.valid) sendEmail()
        else ErrorToast(validRes.message)
      }
    }
    else if (step === 3) {
      // setLoading(true);
      debouncedHandleNext();
    }
    else {
      setStep(step + 1);
    }
  };

  const handleSubmit = async () => {
    if (emailOTP.length > 5 || mobileOTP.length > 5) {
      setIsSubmitting(true);
      // const userData = localStorage.getItem('userDetails')
      const userData = cookieUtils.getSecureCookie('userDetails')

      const userParsedData = userData ? userData : {
        user_id: ''
      }
      _axios.post(`${BASE_URL}/api/email-verification/verify`,
        {
          user_id: userParsedData.user_id,
          name: formData?.name,
          email: formData?.email,
          mobile_number: formData?.mobile_number,
          otp: emailOTP.length > 5 ? emailOTP : mobileOTP,
          verificationToken: verificationToken,  // Add the stored token
          token: token

        })
        .then(async function (response) {
          console.log('response', response)
          console.log('verification response', response);
          debugger
          // Decode the token
          const decodedToken: ExtendedJwtPayload = jwtDecode(response?.data?.verificationToken) ?? {};

          if (decodedToken && Object.keys(decodedToken)?.length === 0) {
            ErrorToast("Something Wrong");
          }
          if (decodedToken?.verified === true) {
            // Store new verification token if provided
            if (response.data.verificationToken) {
              setVerificationToken(response.data.verificationToken);
            }
            const gov_id_document = await uploadFileToBlob(formData.gov_id_document, 'gov_id_document', 'user_details', user?.user_id ?? '');
            const document_certificate = await uploadFileToBlob(formData.document_certificate, 'document_certificate', 'user_details', user?.user_id ?? '');
            const licence_certificate = await uploadFileToBlob(formData.licence_certificate, 'licence_certificate', 'user_details', user?.user_id ?? '');
            const experience_certificate = await uploadFileToBlob(formData.experience_certificate, 'experience_certificate', 'user_details', user?.user_id ?? '');


            _axios.post(`${BASE_URL}/api/user-details`,
              {
                user_id: userParsedData.user_id,
                name: formData?.name,
                email: formData?.email,
                mobile_number: formData?.mobile_number,
                user_salutation: formData?.user_salutation,
                user_type: formData?.user_type,
                document_type: formData?.document_type,
                gov_id_number: formData?.gov_id_number,
                office_address: formData?.office_address,
                gov_id_document: gov_id_document,
                document_certificate: document_certificate,
                experience_certificate: experience_certificate,
                licence_certificate: licence_certificate,
                email_status: formData?.email_status,
                mobile_status: formData?.mobile_status,
                regestration_status: formData?.regestration_status,
                "token": token
              })
              .then(function (details) {
                debugger
                setUserRegistration(details?.data?.data?.[0])
                _axios.post(`${BASE_URL}/api/user-verification-comments`,
                  {
                    user_id: userParsedData?.user_id,
                    name: userParsedData?.name,
                    email: userParsedData?.email,
                    comment: 'Registration request is currently under review.',
                    comments_by: "user",
                    status: 0
                  }
                ).then(function (response) {
                  setTimeout(() => {
                    setIsSubmitting(false);
                    setStep(step + 1);
                  }, 3000);
                })
                console.log('response', response)

                // alert("Submitted successfully")


              }).catch(function (error) {
                // handle error
                console.log(error);
              }).
              finally(() => {
                setIsSubmitting(true);
              })
          }
          if (response?.data?.status == "not verified") {
            ErrorToast('Please enter correct OTP')
          }
        }).catch(function (error) {
          // handle error
          console.log(error);
        })
    }
    else { ErrorToast('Please enter 6 digit OTP') }
  };

  const debouncedHandleNext = useCallback(debounce(handleSubmit, 3000), [emailOTP, mobileOTP, formData]);

  const handleBack = () => {
    if (step > 1) setStep(step - 1);
  };

  useEffect(() => {
    if (step === 4) {
      setTimeout(() => {
        navigate("/user-account-not-verified")
      }, 3000)
    }
  }, [step]
  )

  const userTypeField = regestrationFields?.find((field: any) => field?.uid === 'user_type' && field?.active && field?.options?.length)

  // console.log('userData', JSON.parse(userData as string))
  return (

    <div className={style.pageContainer}>
      <div className={style.formPage}>
        <div className={style.logo}>
          <img src={icon} alt="Logo" style={{ display: 'inline' }} />
          {/* <h5 className={style.mainHeading} >Verification</h5> */}

        </div>
        {/* Step indicator */}

        {/* Your existing form */}
        {step === 1 && (
          <>
            <h5 className={style.mainHeading} >Verification</h5>

            <div className={style.verificationContainer}>
              {/* <br /> */}
              <img src={group1} alt="Logo" className={style.groupLogo} />
              <br />
              <h5 className={style.semiHeading}>Personal Details</h5>
              <div className={style.inputGroup}>
                {regestrationFields?.find((field: any) => field?.registration_field_id == 1 && field?.active == 1) && <div className={style.inputField}>

                  <InputForm
                    title={regestrationFields?.find((field: any) => field?.registration_field_id == 1)?.label_name}
                    isRequired={regestrationFields?.find((field: any) => field?.registration_field_id == 1 && field?.mandatory == 1) ? true : false}
                    isIcon={true}
                    icon={"fa fa-user-o"}
                    placeholder={regestrationFields?.find((field: any) => field?.registration_field_id == 1)?.placeholder_name ?? "Full Name"}
                    type="text"
                    isName={true}
                    disabled
                    value={formData.name}
                    onSuffixChange={(event) => { setFormData({ ...formData, user_salutation: event.target.value }) }}
                  />
                </div>}

                {regestrationFields?.find((field: any) => field?.registration_field_id == 2 && field?.active == 1) && <div className={style.inputField}>
                  <InputForm
                    title={regestrationFields?.find((field: any) => field?.registration_field_id == 2)?.label_name}
                    isRequired={regestrationFields?.find((field: any) => field?.registration_field_id == 2 && field?.mandatory == 1) ? true : false}
                    isIcon={true}
                    icon={"fa fa-envelope-o"}
                    placeholder={regestrationFields?.find((field: any) => field?.registration_field_id == 2)?.placeholder_name ?? "Email"}
                    type="email"
                    disabled
                    value={formData.email}
                  />
                </div>}
              </div>

              <div className={style.inputGroup}>
                {regestrationFields?.find((field: any) => field?.registration_field_id == 3 && field?.active == 1) && <div className={style.inputField}>

                  <InputForm
                    title={regestrationFields?.find((field: any) => field?.registration_field_id == 3)?.label_name}
                    isRequired={regestrationFields?.find((field: any) => field?.registration_field_id == 3 && field?.mandatory == 1) ? true : false}
                    isIcon={true}
                    icon={"fa fa-mobile-phone fa-lg"}
                    placeholder={regestrationFields?.find((field: any) => field?.registration_field_id == 3)?.placeholder_name ?? "Mobile Number"}
                    type="tel"
                    disabled
                    value={formData.mobile_number}
                  />
                </div>}

                {!!userTypeField && (
                  <div className={style.inputField}>
                    <legend className={style.legendTag}>
                      {userTypeField?.label_name || "User Type"}
                      {!!userTypeField?.mandatory && (
                        <span className="text-red-500">{" *"}</span>
                      )}
                    </legend>
                    <select
                      id="role"
                      name="role"
                      className={style.dropdownMenu}
                      value={formData.user_type}
                      onChange={(e) => {
                        setFormData({ ...formData, user_type: e.target.value });
                      }}
                    >
                      {userTypeField?.options?.filter((e: NonNullable<TRegistrationField['options']>[number]) => !!e?.active)?.map((opt: NonNullable<TRegistrationField['options']>[number]) => (
                        <option key={opt?.id || opt.name} value={opt.name}>
                          {opt.name}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </div>
              <div className={style.inputGroup}>
                {regestrationFields?.find((field: any) => field?.registration_field_id == 5 && field?.active == 1) && <div className={style.inputField}>
                  <legend className={style.legendTag}>{regestrationFields?.find((field: any) => field?.registration_field_id == 5)?.label_name} {regestrationFields?.find((field: any) => field?.registration_field_id == 5 && field?.mandatory == 1) && <span className="text-red-500">{' *'}</span>}</legend>
                  <select id="role" name="role" className={style.dropdownMenu} value={formData.document_type} onChange={(e) => { setFormData({ ...formData, document_type: e.target.value }); setDocumentType(e.target.value) }}>
                    <option value="Aadhaar Card">Aadhaar Card</option>
                    <option value="Driving Licence">Driving Licence</option>
                    <option value="Pan Card">Pan Card</option>
                    <option value="Voter Card">Voter Card</option>
                    <option value="Passport">Passport</option>
                  </select>
                </div>}
                {regestrationFields?.find((field: any) => field?.registration_field_id == 6 && field?.active == 1) && <div className={style.inputField}>
                  <InputForm
                    title={documentType}
                    isRequired={regestrationFields?.find((field: any) => field?.registration_field_id == 6 && field?.mandatory == 1) ? true : false}
                    isIcon={true}
                    icon={"fa fa-credit-card"}
                    placeholder={regestrationFields?.find((field: any) => field?.registration_field_id == 6)?.placeholder_name ?? "Enter Number"}
                    type="text"
                    value={documentId}
                    onChange={(e) => { setFormData({ ...formData, gov_id_number: e.target.value }); setDocumentId(e.target.value) }}
                  />
                </div>}
              </div>


              {regestrationFields?.find((field: any) => field?.registration_field_id == 7 && field?.active == 1) && <div className={style.inputField}>
                <p className={style.officeLabel}>  {regestrationFields?.find((field: any) => field?.registration_field_id == 7)?.label_name}{regestrationFields?.find((field: any) => field?.registration_field_id == 7 && field?.mandatory == 1) && <span className="text-red-500">{' *'}</span>} </p>
                <textarea
                  onChange={(e) => {
                    const sanitizedValue = e.target.value.replace(/[^a-zA-Z0-9\s-/]/g, '');
                    setFormData({ ...formData, office_address: sanitizedValue });
                  }}
                  placeholder={regestrationFields?.find((field: any) => field?.registration_field_id == 7)?.placeholder_name ?? "Enter Office Address"}
                  value={formData?.office_address ?? ''}
                  required
                ></textarea>
                {/* <textarea
                  onChange={(e) => { setFormData({ ...formData, office_address: e.target.value }) }}
                  placeholder={regestrationFields?.find((field: any) => field?.registration_field_id == 7)?.placeholder_name ?? "Enter Office Address"}
                  value={formData?.office_address ?? ''}
                  required
                ></textarea> */}
              </div>}
            </div>
          </>
        )}
        {step === 2 && (
          <>
            <GoogleReCaptchaProvider reCaptchaKey="6LdRltoqAAAAAKddCuFxu0SGioWr8tMtYSESl_ol">
              <h5 className={style.mainHeading} >Verification</h5>

              <img src={group2} alt="Logo" className={style.groupLogo} />
              <h5 className={style.semiHeading}>Upload Documents</h5>
              <span className={style.browseLabel}>  {documentType} * </span>
              <div className={style.uploadSection}>
                <FileUploader handleChange={(e: any) => { setFormData({ ...formData, gov_id_document: e }) }} name="file" types={fileTypes} children={
                  <div className={style.uploadContainerDocument}>
                    <label className={style.uploadLable} >Browse</label>
                    <p className={`${style.linkCss} md:w-full lg:w-full`}>
                      {formData?.gov_id_document != '' ? formData?.gov_id_document?.name : 'Drag and drop file here'}
                    </p>
                  </div>

                } />
              </div>

              {formData?.user_type === "Architect" && (
                <>
                  <p className={style.browseLabel}> Degree Certificate *</p>
                  <div className={style.uploadSection}>
                    <FileUploader
                      handleChange={(e: any) => {
                        setFormData({ ...formData, document_certificate: e });
                      }}
                      name="file"
                      types={fileTypes}
                      children={
                        <div className={style.uploadContainerDocument}>
                          <label className={style.uploadLable}>Browse</label>
                          <p className={`${style.linkCss} md:w-full lg:w-full`}>
                            {formData?.document_certificate != ""
                              ? formData?.document_certificate?.name
                              : "Drag and drop file here"}
                          </p>
                        </div>
                      }
                    />
                  </div>

                  <p className={style.browseLabel}>
                    Architect License Certificate *

                  </p>
                  <div className={style.uploadSection}>
                    <FileUploader
                      handleChange={(e: any) => {
                        setFormData({ ...formData, licence_certificate: e });
                      }}
                      name="file"
                      types={fileTypes}
                      children={
                        <div className={style.uploadContainerDocument}>
                          <label className={style.uploadLable}>Browse</label>
                          <p className={`${style.linkCss} md:w-full lg:w-full`}>
                            {formData?.licence_certificate != ""
                              ? formData?.licence_certificate?.name
                              : "Drag and drop file here"}
                          </p>
                        </div>
                      }
                    />
                  </div>
                </>
              )}

              {formData?.user_type === "Engineer" && (
                <>
                  <p className={style.browseLabel}> Degree Certificate *</p>
                  <div className={style.uploadSection}>
                    <FileUploader
                      handleChange={(e: any) => {
                        setFormData({ ...formData, document_certificate: e });
                      }}
                      name="file"
                      types={fileTypes}
                      children={
                        <div className={style.uploadContainerDocument}>
                          <label className={style.uploadLable}>Browse</label>
                          <p className={`${style.linkCss} md:w-full lg:w-full`}>
                            {formData?.document_certificate != ""
                              ? formData?.document_certificate?.name
                              : "Drag and drop file here"}
                          </p>
                        </div>
                      }
                    />
                  </div>

                  <p className={style.browseLabel}>
                    Engineer License Certificate *

                  </p>
                  <div className={style.uploadSection}>
                    <FileUploader
                      handleChange={(e: any) => {
                        setFormData({ ...formData, licence_certificate: e });
                      }}
                      name="file"
                      types={fileTypes}
                      children={
                        <div className={style.uploadContainerDocument}>
                          <label className={style.uploadLable}>Browse</label>
                          <p className={`${style.linkCss} md:w-full lg:w-full`}>
                            {formData?.licence_certificate != ""
                              ? formData?.licence_certificate?.name
                              : "Drag and drop file here"}
                          </p>
                        </div>
                      }
                    />
                  </div>
                </>
              )}
              {formData?.user_type === "Supervisor" && (
                <>
                  <p className={style.browseLabel}> Highest Education Certificate *</p>
                  <div className={style.uploadSection}>
                    <FileUploader
                      handleChange={(e: any) => {
                        setFormData({ ...formData, document_certificate: e });
                      }}
                      name="file"
                      types={fileTypes}
                      children={
                        <div className={style.uploadContainerDocument}>
                          <label className={style.uploadLable}>Browse</label>
                          <p className={`${style.linkCss} md:w-full lg:w-full`}>
                            {formData?.document_certificate != ""
                              ? formData?.document_certificate?.name
                              : "Drag and drop file here"}
                          </p>
                        </div>
                      }
                    />
                  </div>

                  <p className={style.browseLabel}>
                    Experience Certificate *
                  </p>
                  <div className={style.uploadSection}>
                    <FileUploader
                      handleChange={(e: any) => {
                        setFormData({ ...formData, experience_certificate: e });
                      }}
                      name="file"
                      types={fileTypes}
                      children={
                        <div className={style.uploadContainerDocument}>
                          <label className={style.uploadLable}>Browse</label>
                          <p className={`${style.linkCss} md:w-full lg:w-full`}>
                            {formData?.experience_certificate != ""
                              ? formData?.experience_certificate?.name
                              : "Drag and drop file here"}
                          </p>
                        </div>
                      }
                    />
                  </div>
                </>
              )}
              <GoogleReCaptcha onVerify={handleVerify} />
            </GoogleReCaptchaProvider>
          </>
        )}

        {step === 3 && (
          <>
            <GoogleReCaptchaProvider reCaptchaKey="6LdRltoqAAAAAKddCuFxu0SGioWr8tMtYSESl_ol">
              <h5 className={style.mainHeading} >Verification</h5>
              <img src={group3} alt="Logo" className={style.groupLogo} />
              <h5 className={style.semiHeading}>OTP Verification</h5>

              <br />
              <div className={style.otpBox}>
                <div className={style.loginEmail}>
                  <InputForm
                    title={"Enter Email OTP"}
                    placeholder={"Enter Email OTP"}
                    value={emailOTP}
                    onChange={(e) => setEmailOTP(e.target.value)}
                    type="text"
                  />
                  <div className={style.verificationMessage}>
                    Your OTP will expire in 10 min. In case OTP not received <span style={{ cursor: 'pointer' }} onClick={sendEmail}>Click here</span>
                    {/* <span onClick={sendEmail}> Resend </span>{" "} */}
                  </div>
                </div>

                <br />
                <h4 className="pb-4">OR</h4>

                <div className={style.loginEmail}>
                  <InputForm
                    title={"Enter Mobile OTP"}
                    placeholder={"Enter Mobile OTP"}
                    value={mobileOTP}
                    onChange={(e) => setMobileOTP(e.target.value)}
                    type="text"
                  />
                  <div className={style.verificationMessage}>
                    Your OTP will expire in 10 min. In case OTP not received <span style={{ cursor: 'pointer' }} onClick={sendEmail}> Click here</span>
                    {/* <span> Resend </span>{" "} */}
                  </div>
                </div>
              </div>
              <GoogleReCaptcha onVerify={handleVerify} />
            </GoogleReCaptchaProvider>
          </>
        )}

        {step === 4 && (
          <>
            <div className={style.verificationContainer}>


              <img src={tickGreen} alt="Logo" className={style.tickDone} />

              <h2 className={style.boldGreen}>Congratulations!!!</h2>

              <h6 className={style.successfulMessage}>You have registered successfully, you will
                receive <br /> the registration approval status on <br />
                registered Email ID and Mobile Number</h6>
            </div>
          </>
        )}
        {step !== 4 &&
          <>
            {step !== 1 && <button className={style.blackBtn} onClick={handleBack}>
              Back
            </button>}
            <button
              className={style.yellowBtn}
              onClick={step === 3 ? handleSubmit : handleNext}
              disabled={isSubmitting}
            >
              {step === 3 ? (isSubmitting ? "Submitting..." : "Submit") : "Next"}
            </button>
          </>
        }
      </div>
    </div>
  );
};

export default VerificationPage;
